import api from './api';

const projectCommunicationService = {
  getAll: async (params = {}) => {
    const response = await api.get('/project-communications', { params });
    return response.data;
  },
  getStats: async () => {
    const response = await api.get('/project-communications/stats');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/project-communications/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/project-communications', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/project-communications/${id}`, data);
    return response.data;
  },
  addReply: async (id, message) => {
    const response = await api.post(`/project-communications/${id}/replies`, { message });
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/project-communications/${id}`);
    return response.data;
  }
};

export default projectCommunicationService;
